import { GraphqlRestrictionDto } from "../models/output/restriction-output.model";
import { Restriction } from "src/app/models/restriction";
import { GraphqlVehicleWithRestrictionDto } from "../models/output/vehicle-with-restriction-output.model";
import { VehicleWithRestrictions } from "src/app/models/vehicle-with-restrictions";
import { GraphqlFpcWithRestrictionsDto } from "../models/output/fpc-with-restrictions-output.model";
import { FpcWithRestrictions } from "src/app/models/fpc-with-restrictions";

export function convertGraphqlRestrictionOutputToRestriction(input: GraphqlRestrictionDto): Restriction {
  return {
    restrictionId: input.restrictionId,
    displayName: input.displayName,
    restrictionName: input.restrictionName,
    dateCreated: input.dateCreated,
    dateUpdated: input.dateUpdated,
    validFrom: input.validFrom ?? undefined,
    validTo: input.validTo ?? undefined,
    banTestTrack: input.banTestTrack,
    banPublicRoad: input.banPublicRoad,
    cause: input.cause,
    risk: input.risk,
    consequence: input.consequence,
    precondition: input.precondition,
    operatedRestriction: input.operatedRestriction,
    removingCondition: input.removingCondition,
    additionalInformation: input.additionalInformation,
    modifiedBy: input.modifiedBy,
    createdBy: input.createdBy,
    links: input.links,
    responsible: input.responsible,
    approvedBy: input.approvedBy,
    fileUids: input.fileUids ?? [],
    active: input.active,
    removedVehicleName: input.removedVehicleName ?? [],
    fileUidsForRemove: input.fileUidsForRemove ?? [],
    vehicles: (input.vehicles ?? []).map(v => ({
      vehicleId: '',
      vinNo: v.vinNo,
      name: v.name
    })),
    fpcs: (input.fpcs ?? []).map(f => ({
      fpcId: f.fpcId,
      name: f.name,
      category: f.category,
      regTime: f.regTime,
    })),
  };
}

export function convertGraphqlVehicleWithRestrictionsOutputToVehicleWithRestriction(
  input: GraphqlVehicleWithRestrictionDto
): VehicleWithRestrictions {
  return {
    vehicleId: '',
    vinNo: input.vinNo,
    name: input.name,
    restrictions: (input.restrictions ?? []).map(r => convertGraphqlRestrictionOutputToRestriction(r))
  };
}

export function convertGraphqlFpcWithRestrictionsOutputToFpcWithRestrictions(
  input: GraphqlFpcWithRestrictionsDto
): FpcWithRestrictions {
  return {
    fpcId: input.fpcId,
    name: input.name,
    category: input.category,
    regTime: input.regTime,
    restrictions: (input.restrictions ?? []).map(r => convertGraphqlRestrictionOutputToRestriction(r))
  };
}

export function formatBanLocation(input: Pick<GraphqlRestrictionDto, 'banPublicRoad' | 'banTestTrack'>): string {
  const locations: string[] = [];
  if (input.banPublicRoad) locations.push('public road');
  if (input.banTestTrack) locations.push('test track');
  return locations.join(', ');
}
